const ACTIONS = {
  JOIN: "join",
  JOINED: "joined",
  DISCONNECTED: "disconnected",
  CODE_CHANGE: "code_change",
  CODE_SYNC: "code_sync",
  PROCESSING: "processing",
  OUTPUT_RECEIVED: "output_received",
  OUTPUT_CHANGED: "output_changed",
};

export default ACTIONS;
